import { useState, useEffect, useCallback } from 'react';
import { authService } from '../services/auth/auth.service';

export interface SurveyStatus {
  tieneDatosComplementarios: boolean;
  completitud: number;
  camposFaltantes: string[];
}

export const useSurveyStatus = () => {
  const [status, setStatus] = useState<SurveyStatus | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const s = await authService.verificarDatosComplementarios();
      setStatus(s);
    } catch {
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const handler = () => {
      refresh();
    };
    window.addEventListener('datos-complementarios-saved', handler);
    return () => window.removeEventListener('datos-complementarios-saved', handler);
  }, [refresh]);

  return { status, loading };
};
